import React from 'react'

import { TableHead, TableRow, TableCell } from '@mui/material'

interface PositionAlertTableHeaderProps {
  shouldShowFirstHeader: boolean,
  hascomments: boolean
}

export const PositionAlertTableHeader: React.FC<
  PositionAlertTableHeaderProps
> = ({ shouldShowFirstHeader, hascomments }) => {
  return (
    <TableHead>
      <TableRow>
        {shouldShowFirstHeader && <TableCell></TableCell>}
        <TableCell>Tipo</TableCell>
        <TableCell>Creación</TableCell>
        <TableCell>Origen</TableCell>
        <TableCell>Usuario</TableCell>
        <TableCell>Acción</TableCell>
        <TableCell>SKU</TableCell>
        <TableCell>Nombre</TableCell>
        {hascomments && (<TableCell>Comentario</TableCell>)}
        <TableCell>Lote/Fecha Vencimiento</TableCell>
        <TableCell>Cantidad Problemas</TableCell>
        <TableCell>Acciones</TableCell>
      </TableRow>
    </TableHead>
  )
}
